import { render, staticRenderFns } from "./PostTile.vue?vue&type=template&id=00d433a9&scoped=true"
import script from "./PostTile.vue?vue&type=script&lang=js"
export * from "./PostTile.vue?vue&type=script&lang=js"
import style0 from "./PostTile.vue?vue&type=style&index=0&id=00d433a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d433a9",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostTile.vue
// module id = 64
// module chunks = 0